import router from '../router/index'
import { inject, h, createApp } from 'vue'
import { BdDrawer, BdButton } from '@bilibili-business/bili-design'
import { setCommonApp } from '@Utils/setCommonApp'
const noop = () => {}

function drawer(options) {
  let instances = []

  const {
    title = '',
    size = '30%',
    render,
    component,
    okText = '确定',
    cancelText = '取消',
    footerHide = false,
    appendToBody = false,
    beforeClose,
    closeOnPressEscape = true,
    customClass = '',
    destroyOnClose = true,
    modal = true,
    direction = 'rtl',
    showClose = true,
    withHeader = true,
    renderTitle
  } = options
  const props = {
    size,
    appendToBody,
    beforeClose,
    closeOnPressEscape,
    customClass,
    destroyOnClose,
    modal,
    direction,
    showClose,
    withHeader
  }

  const container = document.createElement('div')
  document.body.appendChild(container)

  instances = createApp({
    name: 'BizElDrawer',
    router,
    data: () => {
      return {
        loading: false,
        visible: false,
        disabled: false,
        title
      }
    },
    created() {
      this.visible = true
    },
    methods: {
      onOk(data) {
        options.onOk && options.onOk(data)
        this.destroy()
      },
      onClose() {
        options.onCancel && options.onCancel()
        this.destroy()
      },
      onCancel() {
        if (typeof beforeClose === 'function') {
          beforeClose(this.onClose)
        } else {
          this.onClose()
        }
      },
      destroy() {
        this.loading = false
        this.visible = false
        instances.unmount()
        instances = null
        document.body.contains(container) && document.body.removeChild(container)
      }
    },
    render() {
      const btns = options.buttons || [
        {
          id: 'cancel',
          name: cancelText,
          plain: true,
          style: {
            marginRight: '2px'
          }
        },
        {
          id: 'ok',
          name: okText,
          type: 'primary'
        }
      ]
      let footerBtn = null
      if (!footerHide) {
        footerBtn = h(
          'div',
          {
            style: {
              textAlign: 'right',
              position: 'absolute',
              bottom: 0,
              borderTop: '1px solid #EAECF0',
              padding: '12px 24px',
              left: 0,
              right: 0,
              background: '#fff',
              zIndex: 100
            }
          },
          btns.map(item => {
            return h(
              BdButton,
              {
                size: 'large',
                type: item.type,
                disabled: item.id === 'ok' ? this.disabled : false,
                loading: item.id === 'ok' ? this.loading : false,
                round: true,
                class: item.class || {},
                style: item.style || {},
                onClick: () => {
                  const { id } = item || {}
                  const name = `on${id[0].toUpperCase()}${id.substr(1)}`

                  console.log(this.$refs.drawerBody)
                  if (id === 'ok' && this.$refs.drawerBody && this.$refs.drawerBody.confirm) {
                    this.loading = true

                    const func = this.$refs.drawerBody.confirm()

                    if (func && func.then) {
                      return func
                        .then(data => (options.onOk ? options.onOk(data) : noop()))
                        .then(() => this.destroy())
                        .catch(() => {
                          this.loading = false
                        })
                    } else {
                      options.onOk ? options.onOk(func) : noop()
                      this.destroy()
                      return
                    }
                  }

                  const callback = (options[name] || noop)()
                  if (!callback || !callback.then) {
                    return this.destroy()
                  }
                  this.loading = true
                  callback
                    .then(() => this.destroy())
                    .catch(() => {
                      this.loading = false
                    })
                }
              },
              () => item.name
            )
          })
        )
      }
      return h(
        BdDrawer,
        {
          ...props,
          class: props.customClass,
          modelValue: this.visible,
          onClose: this.onClose
        },
        {
          header: () => (renderTitle === undefined ? h('span', { class: 'bd-drawer__title' }, title) : renderTitle(h, instances)),
          default: () =>
            component === undefined
              ? render(h)
              : h(
                  'div',
                  {},
                  {
                    default: () => [
                      h(component, {
                        ref: 'drawerBody',
                        ...options.props,
                        onDisabled: val => {
                          this.disabled = !!val
                        },
                        onCancel: this.onCancel,
                        onOk: this.onOk
                      }),
                      footerBtn
                    ]
                  }
                )
        }
      )
    }
  })
  setCommonApp(instances)
  instances.mount(container)
  return instances
}
export function destroy() {
  let current = null
  while (instances.length) {
    current = instances.pop()
    current && current.destroy()
  }
}
export function open(options) {
  return drawer(options)
}
export const $elDrawer = {
  open,
  destroy
}
export const elDrawerPlugin = {
  install: (app, options) => {
    app.provide('BizElDrawer', $elDrawer)
    app.config.globalProperties.$elDrawer = $elDrawer
  }
}

// 选项式用this.$elDrawer.open，组合式用usePluginElDrawer().open
export const usePluginElDrawer = () => {
  return $elDrawer
}
